<template>
  <div class="create-user">
    <div class="loader" v-if="loading"></div>
    <div class="card card-primary m-4">
      <!-- <div class="card-header">
        <h3 class="card-title">Add new Roles</h3>
        <div class="card-tools">
          <a class="btn btn-danger"
            ><i class="fas fa-shield-alt"></i> See all Roles</a
          >
        </div>
      </div> -->
      <div class="card-body">
        <div class="form-group">
          <label class="role-title" for="name">Role Name</label>
          <input type="text" name="name"
            class="form-control"
            v-model="roles.name"
            required
          />
        </div>
        <div id="demo" >
        <h5>Assign Permission</h5>
            <div class="d-flex permissions big-screen">
                <div class="User permission-holder">
                  <h5>User</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('User')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Role permission-holder">
                  <h5>Role</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Role')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Employee permission-holder">
                  <h5>Employee</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Viewer')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Audit permission-holder">
                  <h5>Audit</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Audit')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="File permission-holder">
                  <h5>File Access</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('File-Access-Permission')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Reports permission-holder">
                  <h5>Reports</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Report')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Leave permission-holder">
                  <h5>Leave</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Leave-Admin') || permission.name.includes('Can_Access_Leave')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Executive permission-holder">
                  <h5>Executive</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Executive')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
                <div class="Announcements permission-holder">
                  <h5>Announcements</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Announcement')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>

                <div class="Performance Management permission-holder">
                  <h5>Performance Management</h5>
                  <div v-for="(permission,idx) in getPermissions" :key="idx">
                    <div v-if="permission.name.includes('Performance-Management') || permission.name.includes('Final-Review')">
                      <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission">
                      {{formatName(permission.name)}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="small-screen">
            <div class="blocks">
              <div class="User">
                <h5 class="classify">User</h5>
                <div v-for="(permission,idx) in getPermissions" :key="idx">
                  <div v-if="permission.name.includes('User')">
                    <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                    {{formatName(permission.name)}}
                  </div>
                </div>
              </div>

              <div class="Role">
                <h5 class="classify">Role</h5>
                <div v-for="(permission,idx) in getPermissions" :key="idx">
                  <div v-if="permission.name.includes('Role')">
                    <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                    {{formatName(permission.name)}}
                  </div>
                </div>
              </div>

              <div class="Role">
                <h5 class="classify">Employee</h5>
                <div v-for="(permission,idx) in getPermissions" :key="idx">
                  <div v-if="permission.name.includes('Viewer')">
                    <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                    {{formatName(permission.name)}}
                  </div>
                </div>
              </div>
            </div>  
            <div class="blocks">
              <div class="Audit">
                <h5 class="classify">Audit/Reports</h5>
                <div v-for="(permission,idx) in getPermissions" :key="idx">
                  <div v-if="permission.name.includes('Audit')">
                    <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                    {{formatName(permission.name)}}
                  </div>
                </div>
              </div>

              <div class="File">
                <h5 class="classify">File Access</h5>
                <div v-for="(permission,idx) in getPermissions" :key="idx">
                  <div v-if="permission.name.includes('File-Access-Permission')">
                    <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                    {{formatName(permission.name)}}
                  </div>
                </div>
              </div>

              <div class="Leave">
                <h5 class="classify">Leave</h5>
                <div v-for="(permission,idx) in getPermissions" :key="idx">
                  <div v-if="permission.name.includes('Leave-Admin') || permission.name.includes('Can_Access_Leave')">
                    <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                    {{formatName(permission.name)}}
                  </div>
                </div>
              </div>
            </div>
            
            <div class="blocks">
              <div class="Executive">
                <h5 class="classify">Executive</h5>
                <div v-for="(permission,idx) in getPermissions" :key="idx">
                  <div v-if="permission.name.includes('Executive')">
                    <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                    {{formatName(permission.name)}}
                  </div>
                </div>
              </div>
              <div class="Reports">
                <h5 class="classify">Reports</h5>
                <div v-for="(permission,idx) in getPermissions" :key="idx">
                  <div v-if="permission.name.includes('Report')">
                    <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                    {{formatName(permission.name)}}
                  </div>
                </div>
              </div>
              <div class="Announcements">
                <h5 class="classify">Announcements</h5>
                <div v-for="(permission,idx) in getPermissions" :key="idx">
                  <div v-if="permission.name.includes('Announcement')">
                    <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                    {{formatName(permission.name)}}
                  </div>
                </div>
              </div>

              <div class="Performance Management">
                <h5 class="classify">Performance Management</h5>
                <div v-for="(permission,idx) in getPermissions" :key="idx">
                  <div v-if="permission.name.includes('Performance-Management')">
                    <input type="checkbox" :value="permission.id" id="permission.id" v-model="selectedPermission"> 
                    {{formatName(permission.name)}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <button class="btn btn-primary ml-4 mb-4" @click="createRole">Create Role</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { routeNames } from '../js/routeNames';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
  data() {
    return {
      getPermissions: '',
      roles: {
        name: '',
        permissions: ''
      },
      selectedPermission: [],
      loading: false,
    };
  },
  computed: {
    routeNames: () => { return routeNames; }
  },
  mounted() {
    this.loading = true;
    axios.get(this.$hostName + '/getAllPermissions')
      .then((response) => {
        this.getPermissions = response.data;
      })
      .finally(() => {
        this.loading =  false;
      });
  },
  methods: {
    formatName(name){
      return name.split(/[-_]/).join(' ');
    },
    createRole(){
      if(this.roles.name==''){
        Swal.fire({
          text: 'Enter Role Name',
          confirmButtonText: 'Ok',
        });
      }
      else if(this.selectedPermission==''){
        Swal.fire({
          text: 'Select atleast one permission',
          confirmButtonText: 'Ok',
        });
      }
      else{
        this.loading = true;
        this.roles.permissions = this.selectedPermission;
        axios.post(this.$hostName + '/postRole',{
          name: this.roles.name,
          permissions: this.roles.permissions
        })
        .then(response => {
          if(response.status==202){
            this.loading = false;
          Swal.fire({
          text: 'Role already Exists',
          confirmButtonText: 'Ok',
        });
          }
          else{
            this.loading =  false;
            this.$router.push({name:routeNames.manageRole});
          }
        });
      }
      
    },
    goToRoute(route) {
      if(this.navOpen) this.toggleNav();
      if(route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    }

    
  }
};
</script>
<style scoped>
.permission-holder{
  flex-basis: 20%;
}
.permissions{
    -ms-flex-pack: distribute ;
    justify-content: flex-start;
    flex-wrap: wrap;
    row-gap: 30px;
}
.create-user{
  font-family: 'Montserrat';
  top: 2%;
  right: 1%;
  position: absolute;
  left: 60px;
  width: calc(100% - 60px);
}
.role-title{
  font-size: 30px;
  font-weight: bold;
}

.small-screen{
    display: none;
  }


@media only screen and (max-width: 575.98px) {
  .big-screen{
    display: none !important;
  }

  .small-screen{
    display: initial !important;
  }

  .classify{
    margin-top: 40px;
    margin-left: 20px;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .big-screen{
    display: none !important;
  }

  .small-screen{
    display: initial !important;
  }

  .classify{
    margin-top: 20px;
    /* margin-left: 20px; */
  }

  .blocks{
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
  }
}
</style>